/**
 * Default page size for paginated lists.
 * Used by usePaginatedResource and list cache updates (swimmers, news)
 * so query keys match and cache updates apply to the same entry the table reads.
 */
export const DEFAULT_PAGE_SIZE = 50;
